import { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { webUrlNode } from "../../../../constants/appInfo";
import { useSelector } from "react-redux";
import CustomCanvasConfetti from "../../../UI/Confetti";
import HomeworkSettings from "./homeworkGenerator/components/HomeworkSettings";
import SelectedQuestionsBar from "./homeworkGenerator/components/SelectedQuestionsBar";
import TestSelectorModal from "./homeworkGenerator/components/TestSelectorModal";

import QuestionPicker from "./homeworkGenerator/components/QuestionPicker";
import { buildHomeworkTestPayload } from "./homeworkGenerator/utils/buildHomeworkTestPayload";
const API = "https://api.ilogically.com/api";
const DOMAIN = "app.domain.com";

export default function HomeworkEditor({setQuizObject,onClose,id,contentId}) {
  const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const [fireConfetti ,setFireConfetti] =useState(false)

  const isEdit = Boolean(id);
const languages = [
"English","Hindi","Marathi","Gujarati","Punjabi","Bengali",
"Tamil","Telugu","Kannada","Malayalam","Odia","Assamese",
"Urdu","Sanskrit","Konkani","Manipuri","Bodo","Dogri",
"Maithili","Santali","Kashmiri","Sindhi","Nepali"
];  const user_id = useSelector((state)=>state?.user?.user?.user_id)


  const [form, setForm] = useState({
    title: "",
    description: "",
    instructions: "",
    contentType: "test"
  });

  
  const [formQData,setFormQData] = useState();
  
  const [quizData, setQuizData] = useState();
    
  function update(e){

    const updated = {
      ...formQData,
      [e.target.name]:e.target.value
    };

    setFormQData(updated);

    setQuizData({
      post_author:user_id,
      post_title:updated.testName,
      post_type:"mock",
      visibility:"public",
      post_parent:1,
      course_id:1,

      ...updated
    });

  }
  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  const loadHomework = async () => {

    const res = await axios.get(
      `${webUrlNode}/api/homework/${id}`,
      { params: {  appToken: AppToken } }
    );

    setForm(res.data.item);

  };

  useEffect(() => {
  setFormQData({
    testName:form.title,
    overallTestTime:"30",
    difficultyLevel:'{"ID":"1","post_title":"Basic"}',
    testLanguage:'{"ID":"4","post_title":"English"}',
    testStatus:'{"ID":"1","post_title":"Homework"}',
    cutOffPercent:"80",
    testReAttempts:"3",
    testInterfaceTheme:"CBT",
    testPalletOrPage:"pallet",
    palletDirection:"right",
    pagenationDirection:"top",
    isCreateSections:"yes",
    isLockSections:"yes"
  })
  
    if(isEdit){
      loadHomework();
    }

  }, []);
  const createHomework = async () => {

  try {

    const selectedQuestions =
      questions.filter(q => selected.includes(q.ID));

    const payload = buildHomeworkTestPayload({
      appId:appId,
      appToken:AppToken,
      quizData:{
      post_author:user_id,
      post_title:form.title,
      post_type:"mock",
      visibility:"public",
      post_parent:1,
      course_id:1,
     overallTestTime:"30",
    difficultyLevel:'{"ID":"1","post_title":"Basic"}',
    testLanguage:'{"ID":"4","post_title":"English"}',
    testStatus:'{"ID":"1","post_title":"Homework"}',
    cutOffPercent:"80",
    testReAttempts:"3",
    testInterfaceTheme:"CBT",
    testPalletOrPage:"pallet",
    palletDirection:"right",
    pagenationDirection:"top",
    isCreateSections:"yes",
    isLockSections:"yes"
    },
      questions:selectedQuestions?.length?selectedQuestions:[{
    "number": 1,
    "question": "Question 1",
    "questionInstructions": "<p><strong>Which of the following best describes the term 'Public Debt'?</strong></p>",
    "options": [
        "The total amount of money owed by the citizens of a country",
        "The total investments made by the government",
        "The total revenue generated by the government",
        "The total amount of money owed by the government to its creditors"
    ],
    "correctOptionIndex": 3,
    "questionType": "MCQ",
    "marks": "1",
    "negativeMarks": "0.33",
    "difficulty": "Easy",
    "responseSpeed": "35",
    "sectionName": "Demo",
    "relatedTopics": [
        "Economy"
    ],
    "explanation": "<h1><strong>Correct Answer:</strong> <strong>option 4 - The total amount of money owed by the government to its creditors</strong></h1><h2><strong>Step-by-step solution / explanation:</strong></h2><p>1. Public debt refers to the borrowing done by the government to meet expenditure beyond its income.</p><p>2. This borrowing is taken from creditors like banks, financial institutions, and the public through bonds/securities.</p><p>3. Hence, public debt is the total money that the government must repay to its creditors.</p><h2><strong>Why this option is correct (detailed):</strong></h2><p>Option 4 correctly defines public debt as government’s total outstanding borrowings payable to creditors.</p><h2><strong>Why other options are wrong:</strong></h2><ul><li><strong>Option 1:</strong> That describes private/citizen debt, not government debt.</li><li><strong>Option 2:</strong> Investments by the government are not called debt.</li><li><strong>Option 3:</strong> Revenue is income, not borrowing.</li></ul>",
    "aiVerifiedAnswerExplanation": false,
    "confidenceScore": null,
    "answerConfidenceReason": "",
    "aiNotes": "",
    "conceptTags": [],
    "questionSourceType": "Homework",
    "hint": "",
    "commonMistake": ""
}]
    });

    // STEP 1: create test
    const res = await axios.post(
      `${API_BASE}/pyq-import/create-test`,
      payload
    );

    const testId = res.data.testId;

    // STEP 2: create homework linked to test

    await axios.post(
      `${webUrlNode}/api/homework`,
      {
        title: form.title,
        description: "",
        instructions: "",
        coursePostId: 1,
        contentId: testId,
        contentType: "test"
      },
      { params:{ appToken:AppToken } }
    );

   
        setFireConfetti(true)

  } catch(e){
    console.error(e);
  }

};

  const saveHomework = async () => {

    try{

      if(isEdit){

        await axios.patch(
          `${webUrlNode}/api/homework/${id}`,
          form,
          { params:{  appToken: AppToken } }
        );

        setFireConfetti(true)
      } else {

        await axios.post(
          `${webUrlNode}/api/homework?appToken=${AppToken}`,
          {
            ...form,
             
            coursePostId: 1
          }
        );
        setFireConfetti(true)

      }


    }catch(err){

      console.error(err);

    }

  };
  
       const [activeStep, setActiveStep] = useState(1);
       const [activeSubStepOne, setActiveSubStepOne] = useState(3);
       
       const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
       const [activeSubStepThree, setActiveSubStepThree] = useState(0);
       const [activeSubStepFour, setActiveSubStepFour] = useState(0);
       const [activeSubStepFive, setActiveSubStepFive] = useState(0);
   const steps = ([{number:1,name:"Homework Mode"},{number:2,name:" Homework Settings "},{number:3,name:"Create "}]);
    const subSteps = [1, 2, 3, 4, 5];
    const subStepOneTotal= 3;
    const subStepTwoTotal= 3;
    const subStepThreeTotal= 3;
    const subStepFourTotal= 3;
    const subStepFiveTotal= 3;
    ;

    const [showSettings,setShowSettings] = useState(false)
const [closeQuePicker,setCloseQuePicker] = useState(false)

  const [testId, setTestId] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [selected, setSelected] = useState([]);
const [showTestModal,setShowTestModal]=useState(false);
const [selectedTest,setSelectedTest]=useState(null);
  const API_BASE = "https://api.ilogically.com/api";
       const appId = useSelector((state)=>state?.app?.app?.ID);
 
  async function loadQuestions(id) {

    const res = await axios.get(
      `${API_BASE}/tests/${id}/questions`,
      { params:{ appToken:AppToken } }
    );

    setQuestions(res.data.items);

  }
  return (
    <div >
 <>
       
    
 
  
    <div style={{}}>
       {fireConfetti && ( 
        <CustomCanvasConfetti AnimType="firework" />
        
      )} 
</div>
 <div   onClick={()=>onClose(false)} className="appDesignPopUpOpacity" style={{zIndex:"99",cursor:"pointer"}} > </div>
        <div   className="AreYouSurePopUp" style={{borderRadius: '20px',zIndex:"100",top:"50px",bottom:"0px"}}>
       
 {!isEdit ?
      
 <> <div   className=" progress-bar-container "style={{position:"relative",zIndex:"99"}}> 
   <div className="progress-bark">
        {steps?.map((step) => (<div className="animCirclek"   onClick={()=>{
          setActiveStep(step?.number)
        if(step?.number==1){
            setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==2){ 
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==3){ 
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
          }else if(step?.number==4){  
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
          }
        }} style={{position:"relative"}} key={step?.number}>
          <div
            
            className={`circlek ${step?.number <= activeStep ? "activek" : ""}` }
            style={{background: `${step?.number ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step?.number ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step?.number ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step?.number ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step?.number ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step?.number}
          </div>
          <div align="center" style={{width:"110px",position:"absolute",top:"55px",fontSize:"14px"}}>{step?.name}</div>
          </div></div>
        ))}<div style={{width:"95%",height:"5px",background:"rgb(86, 82, 131)",position:"absolute",left:"0px",top:"25px",right:"0px"}}></div>
      </div>  
    
      </div>
<div className="bookmarkListScroll" style={{overflowY:"auto",overflowX:"hidden",}}>
{activeStep==1?<div>
    <div className="">
    
<div  className="ikcraft_login-input-card">
  
<textarea className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Homework Title `} type="text"
  rows={1} name="title" value={form.title}
          onChange={handleChange}/></div>


</div>
<div style={{display:"flex",justifyContent:"center"}}>
<button style={{position:"relative",fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.41)",width:"140px",border:"0px",borderRadius:"15px",cursor:"pointer",zIndex:99999,height:"55px"}}  onClick={()=>setShowTestModal(true)}>
Select Test
</button></div>
      {showTestModal && (

  <TestSelectorModal
    onSelect={(test)=>{

      setSelectedTest(test);setCloseQuePicker(true)
      loadQuestions(test.ID);

    }}
    onClose={()=>{setShowTestModal(false);}}
  />

)}

      {closeQuePicker && (

        <QuestionPicker
          questions={questions}
          selected={selected}
          setSelected={(v)=>{setSelected(v);;setActiveStep(2)}}
          onClose= {()=>{setCloseQuePicker(false)}}
        />

      )}


<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onClick={()=>{onClose(false)}}    className=" CoursesPreviewTopBtn"  type="submit"
 > Cancel </button>
<button  onClick={()=>{setActiveStep(2)}}
         style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > Next </button>
</div>
</div>:activeStep==2?<>

 <div style={overlayStyle}>

      <div style={modalStyle}>

        <h3>Homework Settings</h3>

<label>Homework  Time </label>
        <input className="CreateCourseStepsOuterTextbox"
          name="overallTestTime"
          placeholder="Time (minutes)"
          value={formQData.overallTestTime}
          onChange={update}
        />

        <label>Difficulty</label>
        <select className="CreateCourseStepsOuterTextbox"
          name="difficultyLevel"
          value={formQData.difficultyLevel}
          onChange={update}
        >
          <option value='{"ID":"1","post_title":"Basic"}'>Basic</option>
          <option value='{"ID":"2","post_title":"Intermediate"}'>Intermediate</option>
          <option value='{"ID":"3","post_title":"Advanced"}'>Advanced</option>
        </select>

        <label>Language</label>
        <select className="CreateCourseStepsOuterTextbox" name="testLanguage" onChange={update}>

{languages.map((lang,i)=>(

<option
key={i}
value={JSON.stringify({
ID:100+i,
post_title:lang
})}
>
{lang}
</option>

))}

</select>

        <label>Cutoff %</label>
        <input className="CreateCourseStepsOuterTextbox"
          name="cutOffPercent"
          value={formQData.cutOffPercent}
          onChange={update}
        />

        <label>Reattempts</label>
        <input className="CreateCourseStepsOuterTextbox"
          name="testReAttempts"
          value={formQData.testReAttempts}
          onChange={update}
        />



      </div>

    </div>
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onClick={()=>{setActiveStep(1)}}    className=" CoursesPreviewTopBtn"  type="submit"
 > Back </button>
<button  onClick={()=>{setActiveStep(3)}}
          style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > Next </button>
</div></>:activeStep==3?<>

      <SelectedQuestionsBar
        selectedCount={selected.length}
      />
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onClick={()=>{setActiveStep(2)}}    className=" CoursesPreviewTopBtn"  type="submit"
 > Back </button>
<button  onClick={createHomework}
        style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > Create Homework </button>
</div> </>:""}
</div></>:
<div className="bookmarkListScroll" style={{overflowY:"auto",overflowX:"hidden",}}>
<div><h2>Edit Homework</h2></div>
    <div className="">
    
<div  className="ikcraft_login-input-card">
  
<textarea className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Homework Title `} type="text"
  rows={1} name="title" value={form.title}
          onChange={handleChange}/></div>
<div  className="ikcraft_login-input-card">
  
<textarea className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Description `} type="text"
  rows={2} name="description"
          value={form.description}
          onChange={handleChange}/></div>
<div  className="ikcraft_login-input-card">
<textarea  className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}}  placeholder={`Add Instructions`} type="text"
  rows={2}  name="instructions"
          value={form.instructions}
          onChange={handleChange}/></div>


</div>

<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onClick={()=>{onClose(false)}}    className=" CoursesPreviewTopBtn"  type="submit"
 > Cancel </button>
 <div style={{display:"flex",justifyContent:"center"}}>
<button  onClick={()=>setQuizObject(contentId)}style={{position:"relative",fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.41)",width:"170px",border:"0px",borderRadius:"15px",cursor:"pointer",zIndex:99999,height:"55px"}} 
>
Edit Homework
</button></div>
<button  onClick={saveHomework}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > Update </button>
</div> 
</div>}


     </div>

     <div>
     </div>

    
     
     </>
      


    </div>
  );
}



const overlayStyle = {
  
  maxHeight:"55vh",
};

const modalStyle = {
  background:"#fff",
  padding:"20px",
  overflow:"auto",
  borderRadius:"8px",
  display:"flex",
  flexDirection:"column",
  gap:"10px"
};